import { Component } from "@angular/core";
import { ConfirmationDialogComponent } from "@common/ux/adapt-common-dialog/confirmation-dialog.component/confirmation-dialog.component";

@Component({
    selector: "adapt-workflow-confirm-dialog",
    templateUrl: "./workflow-confirm-dialog.component.html",
    styleUrls: ["./workflow-confirm-dialog.component.scss"],
    standalone: false,
})
export class WorkflowConfirmDialogComponent extends ConfirmationDialogComponent { }
